import CouponSummary from '../../coupons/coupons.desktop';

export default CouponSummary;
